import {CategoryCode} from '../insurance/category';

export interface QuestionnaireMetadata {
  status: QuestionnaireStatus;
  categoryCode?: CategoryCode;
  questionsLength?: number;
  questionIndex?: number;
}

export enum QuestionnaireStatus {
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
  FORCE_STOP = 'FORCE_STOP',
}
